import React from 'react';
import { Calendar } from 'lucide-react';
import { newsArticles } from '../data/mockData';
import { useLanguage } from '../contexts/LanguageContext';

const MediaSection = () => {
  const { t } = useLanguage();
  
  return (
    <section id="media" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#DF6A6A] font-semibold mb-2">{t('media.label')}</p>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#36344D] mb-4">
            {t('media.title')}
          </h2>
          <p className="text-lg text-gray-600">
            {t('media.subtitle')}
          </p>
        </div>

        {/* News Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {newsArticles.slice(0, 6).map((article) => (
            <a
              key={article.id}
              href={article.link}
              className="group bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
            >
              <div className="relative overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-56 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-[#DF6A6A] text-white px-3 py-1 rounded-full text-xs font-semibold flex items-center space-x-1">
                  <Calendar className="w-3 h-3" />
                  <span>{article.date}</span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#36344D] mb-3 group-hover:text-[#DF6A6A] transition-colors">
                  {article.title}
                </h3>
                <p className="text-gray-600 text-sm line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </a>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-12">
          <a 
            href="#quote"
            className="text-[#36344D] hover:text-[#DF6A6A] font-semibold transition-colors duration-300"
          >
            {t('media.pressContact')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default MediaSection;